import React from "react";

// plugin
import { Trans } from "@herob191/gatsby-plugin-react-i18next";

// style
import "./contactScript.scss";

// context

// component

// util
import dataJson from "../../content/data/data.json";
import FlashHover from "../flashHover/flashHover";

// svg
import At from "../../svg/script/@.svg";
import Valencia from "../../svg/script/Valencia.svg";
import Instagram from "../../svg/script/Instagram.svg";
import PhonePrefix from "../../svg/script/34.svg";
import Carles from "../../svg/script/Carles.svg";

// component
export default function ContactScript() {
	const data = dataJson;

	return (
		<div className="contactScript">
			<FlashHover>
				<a
					href="https://maps.app.goo.gl/AA12eYCxWfNbuSbA9"
					target="_blank"
					rel="noopener noreferrer"
				>
					<span className="h2">{data.addressShort}</span>
					<Valencia className="script valencia" />
					<span className="p2 underline">
						<Trans>Visita</Trans>
					</span>
				</a>
			</FlashHover>
			<FlashHover>
				<a href={`mailto:${data.email}`}>
					<span className="h2">
						{data.email.split("@")[0]}
						<span className="transparent">@</span>
						{data.email.split("@")[1]}
						<At className="script emailAt" />
					</span>
					<span className="p2 underline">
						<Trans>Escribe</Trans>
					</span>
				</a>
			</FlashHover>
			<FlashHover>
				<a
					href="https://www.instagram.com/telitaestudio/"
					target="_blank"
					rel="noopener noreferrer"
				>
					<Instagram className="script instagram" />
					<span className="h2">@{data.instagram}</span>
					<span className="p2 underline">
						<Trans>Sigue</Trans>
					</span>
				</a>
			</FlashHover>
			<FlashHover>
				<a href={`tel:+34${data.phone}`}>
					<span className="h2">
						(+<span className="transparent">34</span>) {data.phone}
						<PhonePrefix className="script phonePrefix" />
					</span>
					<Carles className="script carles" />
					<span className="p2 underline">
						<Trans>Llama</Trans>
					</span>
				</a>
			</FlashHover>
		</div>
	);
}
